import React from "react"
import {
  Wrapper,
  NBLInfoContent,
  NBLMiddleInfoContent,
} from "./../../PrintListContent.style"

import { t } from "i18next"
import {
  ReceiptSiblingUpperLimitManagement,
  SiblingChild,
} from "../../../../types"
import { PRINT_CONFIGURATION_OPTION_VALUES } from "../../../../constants"
import { YearMonth } from "../../common/header/YearMonth"
import { ManagementFacility } from "../../common/header/ManagementFacility"
import { DefaultFormat } from "../body/DefaultFormat"
import { DefaultUpperMonthLimit } from "../../common/header/upperMonthLimit/DefaultUpperMonthLimit"
import { DefaultUpperLimitManagementResult } from "../../common/header/upperLimitManagementResult/DefaultUpperLimitManagementResult"
import { DefaultSignature } from "../../common/footer/signature/DefaultSignature"
import { ShizuokaChildDetail } from "../header/childDetail/ShizuokaChildDetail"
import { ShizuokaSheetTitle } from "../header/sheetTitle/ShizuokaSheetTitle"
import { maskDisabilityWord } from "../../common/utils"

type Props = {
  receiptSiblingUpperLimitManagement: ReceiptSiblingUpperLimitManagement
  siblingChildren: SiblingChild[]
  printConfig: string[]
}

const FOOTER_TEXT =
  "この様式は、静岡市で同一世帯に障害福祉サービスを利用する障害児が複数いる場合の利用者負担額上限管理に使用するものです。この様式により上限管理を行う場合は、この様式を関連事業所に送付して請求明細書を作成するとともに、請求月10日までに静岡市に提出してください。この様式により請求明細書を作成した場合には、当該受給者の上限管理結果票を国保連に送信しないでください。"

export function ShizuokaFlame({
  receiptSiblingUpperLimitManagement,
  siblingChildren,
  printConfig = [],
}: Props) {
  return (
    <Wrapper>
      {printConfig.includes(
        PRINT_CONFIGURATION_OPTION_VALUES.PRINT_FORM_NUMBER
      ) && <small>{t("(Form 2)")}</small>}

      {/* --- Start Header */}
      <ShizuokaSheetTitle printConfig={printConfig} />
      <YearMonth
        year={receiptSiblingUpperLimitManagement.year}
        month={receiptSiblingUpperLimitManagement.month}
      />
      <NBLInfoContent length={1}>
        <div className={"top__table_content"}>
          <ShizuokaChildDetail
            municipalityNumber={
              receiptSiblingUpperLimitManagement.municipality_number
            }
            siblingChildren={siblingChildren}
            parentName={receiptSiblingUpperLimitManagement.parent_name}
            printConfig={printConfig}
          />
        </div>
        <div className={"top__table_content"}>
          <ManagementFacility
            facilityName={receiptSiblingUpperLimitManagement.facility_name}
            facilityNumber={receiptSiblingUpperLimitManagement.facility_number}
          />
        </div>
      </NBLInfoContent>
      <NBLMiddleInfoContent>
        <div className={"NBLMiddleInfoContent"}>
          <div className={"nbl_info_top_content"}>
            <DefaultUpperMonthLimit
              burdenMaxMonth={
                receiptSiblingUpperLimitManagement.burden_max_month
              }
            />
          </div>
          <div className={"nbl_info_bottom_content"}>
            <DefaultUpperLimitManagementResult
              managementResult={
                receiptSiblingUpperLimitManagement.management_result
              }
            />
          </div>
        </div>
      </NBLMiddleInfoContent>
      {/* --- End Header */}

      {/* --- Start Body */}
      <DefaultFormat
        facilities={receiptSiblingUpperLimitManagement.facilities}
        totalAmount={receiptSiblingUpperLimitManagement.total_amount}
        totalBurdenAmount={
          receiptSiblingUpperLimitManagement.total_burden_amount
        }
        managementResultBurdenAmount={
          receiptSiblingUpperLimitManagement.management_result_burden_amount
        }
        printConfig={printConfig}
      />
      {/* --- End Body */}

      {/* --- Start Footer */}
      <DefaultSignature printConfig={printConfig} />
      <hr />
      <p style={{ fontSize: "0.8rem" }}>
        {maskDisabilityWord(FOOTER_TEXT, printConfig)}
      </p>
      {/* --- End Footer */}
    </Wrapper>
  )
}
